<template>
    <div class="item cf" @click="openPage">

        <div class="item-content fl relative">

            <div class="item-content-text">
                <span v-if="tag">#</span>
                {{ data.title || data.name }}
                <span v-if="tag">#</span>
            </div>

            <div v-if="tag && keyword === 'topic'" class="item-content-tag absolute">
                {{ data.type === 1 ? '热议' : data.type === 2 ? '投票' : '观点PK' }}
            </div>

            <div v-if="tag && keyword === 'activity'" class="item-content-tag absolute">
                {{data.type === 1 ? '福利' : '应援' }}
            </div>

        </div>

        <v-image class="fr item-img" :src="data.picture || data.cover_id || require('../../assets/images/banner/banner5.png')" />

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image';
export default {
    name: "item",
    mixins: [mixin],
    components: {
        vImage
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            }
        },
        tag: {
            type: Boolean,
            default: false
        },
        keyword: {
            type: String,
            default: 'topic'
        }
    }
}
</script>

<style scoped src="./style.css"></style>
